/**
 * @generated SignedSource<<307f32246047725fb3a98762db2f3760>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "path"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "locale",
        "variableName": "locale"
      },
      {
        "kind": "Variable",
        "name": "path",
        "variableName": "path"
      }
    ],
    "kind": "ScalarField",
    "name": "routeWithTargetLocale",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LocaleSwitchFetchRouteWithTargetLocaleQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LocaleSwitchFetchRouteWithTargetLocaleQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bace36520b785f4c12bf8a8b8f490a14",
    "id": null,
    "metadata": {},
    "name": "LocaleSwitchFetchRouteWithTargetLocaleQuery",
    "operationKind": "query",
    "text": "query LocaleSwitchFetchRouteWithTargetLocaleQuery(\n  $path: String!\n  $locale: String!\n) {\n  routeWithTargetLocale(path: $path, locale: $locale)\n}\n"
  }
};
})();

node.hash = "7e9604b2c765521f73256594066b5c60";

module.exports = node;
